<div (clickOutside)="dateTimePicker(false); onBlur()">
  <div class="floating-input-wrapper"
       [class.focused]="isFocused"
       [class.has-value]="hasValue"
       [class.disabled]="disabled">
    <div class="floating-input-container">
      <input 
        type="text" 
        class="floating-input"
        [class]="ngClass"
        [(ngModel)]="displayValue"
        name="{{field.code}}"
        id="{{field.code}}"
        autocomplete="off"
        [disabled]="disabled"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="clearModel()"
        placeholder=" "
      />
      <label class="floating-label" [class.floating]="isFocused || hasValue">
        <img
          src="assets/icons/required-asterisk.svg"
          *ngIf="required"
          [attr.alt]="'alt.requiredField' | translate"
        >
        {{ label || field.placeHolder?.ru }}
        <!-- <span class="required-asterisk" *ngIf="required"></span> -->
      </label>
    </div>
  </div>
  <div class="dateTimePickerWrapper">
    <div class="input-group dateTimePicker" *ngIf="dateTimePickerVisible">
      <ngb-datepicker #dp [(ngModel)]="date" (ngModelChange)="onDateSelect($event)" style="margin: 10px;"></ngb-datepicker>
      <ngb-timepicker [(ngModel)]="time" [seconds]="true" style="margin: 10px;" (ngModelChange)="onTimeSelect($event)"></ngb-timepicker>
    </div>
  </div>
</div>
